import styled from "styled-components";
import themes from "@/styles/themes";
import {mdiClose} from "@mdi/js";
import Icon from "@mdi/react";
import { useDispatch, useSelector} from "react-redux";
import {AppEnum} from "@/enums/AppEnum";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import Events from "@/utils/Events";
import { SET_MODAL } from "@/store/slices/appSlice";

const Block = styled.div`
  background: white;
  padding: 34px 38px;
  text-align: center;
  border-radius: 5px;
  box-shadow: 0 7px 40px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #d6d6d6;
  position: relative;
`
const ContentArea = styled.div`
    color: ${themes.greyNormal};
  position: relative;
  width: 258px;
`
const IconDiv = styled.div`
  background: ${themes.estadao};
  color: ${themes.white};
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  margin: 8px 0 12px 0;
`
const CallAction = styled.p`
  color: ${themes.estadao};
  font-weight: 700;
  line-height: 1.33;
  margin:0;
  font-size: 20px;
`
const Text = styled.p`
  font-size: 12px;
  margin: 0 0 16px 0;
`
const SubTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  margin: 12px 0;
`
const CloseButton = styled.button`
  background: none;
  border: none;
  color: #1e1e21;
  cursor: pointer;
  position: absolute;
  right: 12px;
  top: 12px;

  svg {
    width: 14px;
    height: 14px;
  }
`
export const AnotherOfferButton = styled.a`
  background: ${themes.estadao};
  border: none;
  color: white;
  font-weight: 700;
  padding: 11.5px 34px;
  display: inline-block;
  margin:0;
  text-transform: uppercase;
  border-radius: 5px;
  cursor: pointer;
`
export default function ImpossibilidadeEntrega() {
    const queryParams = useSearchParams()
    const offer_type = useSelector(GET_OFFER_TYPE)
    const dispatch = useDispatch()
    const events = new Events();

    useEffect(()=>{
      events.trigger("endereco_entrega_fora_entrega", { offer_type })
    });

    return (
        <Block>
              <CloseButton onClick={() => {
                dispatch(SET_MODAL({type: null, show: false})), events.trigger("endereco_entrega_fechar_fora_entrega", { offer_type })
            }}><Icon path={mdiClose} size={1}></Icon></CloseButton>
            <ContentArea>
                <IconDiv>
                  <img src={'/imgs/newspaper.svg'} />
                </IconDiv>
                <CallAction>
                    Região fora da área de entrega do Jornal Impresso!
                </CallAction>
                <SubTitle>
                    Aproveite as nossas ofertas digitais!
                </SubTitle>
                <Text>
                    Tenha acesso ilimitado a todo o conteúdo do Portal Estadão com ofertas imperdíveis.
                </Text>
                <AnotherOfferButton 
                    onClick={() => events.trigger("endereco_entrega_fora_entrega_oferta", { offer_type })} 
                    href={`${AppEnum.OFERTA_REDIRECIONAR}?${queryParams.toString()}`}>
                    Ver Ofertas
                </AnotherOfferButton>
            </ContentArea>
        </Block>
    )
}